import React from 'react';
import { motion } from 'framer-motion';
interface RatioTableProps {
  headers: string[];
  rows: Array<Array<string | number>>;
  highlightRow?: number;
  highlightCol?: number;
  label?: string;
  mode?: 'stimulus' | 'support';
}
export function RatioTable({
  headers,
  rows,
  highlightRow,
  highlightCol,
  label,
  mode = 'support'
}: RatioTableProps) {
  const isStimulus = mode === 'stimulus';
  return <motion.div initial={{
    opacity: 0,
    y: 6
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: [0.22, 1, 0.36, 1]
  }} className="bg-slate-50 rounded-xl border border-slate-100 overflow-hidden" data-id="element-8381">
      {label && <div className={`text-center font-semibold text-slate-700 border-b border-slate-100 ${isStimulus ? 'px-3 py-2 text-xs' : 'px-4 py-3 text-sm'}`} data-id="element-8382">
          {label}
        </div>}
      <div className={`overflow-x-auto ${isStimulus ? 'p-3' : 'p-4'}`} data-id="element-8383">
        <table className="w-full border-collapse" data-id="element-8384">
          <thead data-id="element-8385">
            <tr data-id="element-8386">
              {headers.map((header, i) => <th key={i} className={`text-left font-bold border-b-2 ${isStimulus ? 'p-2 text-xs' : 'p-3 text-sm'} ${highlightCol === i ? 'bg-indigo-100 border-indigo-300 text-indigo-900' : 'bg-slate-100 border-slate-300 text-slate-700'}`} data-id="element-8387">
                  {header}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-8388">
            {rows.map((row, rowIndex) => <tr key={rowIndex} className={highlightRow === rowIndex ? 'bg-indigo-50' : 'bg-white'} data-id="element-8389">
                {row.map((cell, cellIndex) => <td key={cellIndex} className={`border-b border-slate-200 ${isStimulus ? 'p-2 text-xs' : 'p-3 text-sm'} ${highlightRow === rowIndex || highlightCol === cellIndex ? 'font-bold text-indigo-900' : 'text-slate-700'}`} data-id="element-8390">
                    {cell}
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>
    </motion.div>;
}